import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EDIT_DISCOUNTS_FEATURE_KEY, EditDiscountsState, getDiscount } from './edit-discounts.reducer';

export const selectEditDiscountsState = createFeatureSelector<EditDiscountsState>(EDIT_DISCOUNTS_FEATURE_KEY);

export const selectDiscount = createSelector(selectEditDiscountsState, getDiscount);
